export default __webpack_public_path__ + "media/guidelines/static-9efe442d.png";